import {Button, alpha, css, styled} from '@mui/material';
import {CarrouselTypeEnum} from 'presentation/constants/carrouselTypeEnum';
import {StyledButtonProps, StyledProps} from './types';

const OuterContainer = styled('div')<StyledProps>`
	position: relative;
	overflow: hidden;

	${({$type, $hasLeftEdgeFade}) =>
		($type === CarrouselTypeEnum.ARROWS || $type === CarrouselTypeEnum.ARROWS_DOTS) &&
		$hasLeftEdgeFade &&
		css`
			&::before {
				content: '';
				height: 100%;
				width: 32px;
				rotate: -180deg;
				background: linear-gradient(
					90deg,
					rgba(0, 0, 0, 0) 83.61%,
					rgba(0, 0, 0, 0.1) 100%
				);

				border-right: 1px solid;

				border-image-source: linear-gradient(
					180deg,
					rgba(0, 0, 0, 0) 0%,
					rgba(0, 0, 0, 0.08) 4.3%,
					rgba(0, 0, 0, 0.08) 95.87%,
					rgba(0, 0, 0, 0) 100%
				);

				position: absolute;
				top: 0;
				left: -1px;
				z-index: 1;
			}
		`}

	${({$type, $hasRightEdgeFade}) =>
		($type === CarrouselTypeEnum.ARROWS || $type === CarrouselTypeEnum.ARROWS_DOTS) &&
		$hasRightEdgeFade &&
		css`
			&::after {
				content: '';
				height: 100%;
				width: 32px;
				background: linear-gradient(
					90deg,
					rgba(0, 0, 0, 0) 83.61%,
					rgba(0, 0, 0, 0.1) 100%
				);
				border-right: 1px solid;

				border-image-source: linear-gradient(
					180deg,
					rgba(0, 0, 0, 0) 0%,
					rgba(0, 0, 0, 0.08) 4.3%,
					rgba(0, 0, 0, 0.08) 95.87%,
					rgba(0, 0, 0, 0) 100%
				);
				position: absolute;
				top: 0;
				right: -1px;
				z-index: 1;
			}
		`}

	${({$type, $hasRightEdgeFade, $hasLeftEdgeFade}) =>
		($type === CarrouselTypeEnum.DOTS ||
			$type === CarrouselTypeEnum.ARROWS_DOTS ||
			$type === CarrouselTypeEnum.NUMBERS) &&
		css`
			border-radius: ${$hasRightEdgeFade || $hasLeftEdgeFade ? 0 : 8}px;
		`}
`;

const InnerContainer = styled('div')<StyledProps>`
	display: flex;
	gap: 8px;

	${({$type}) =>
		$type === CarrouselTypeEnum.NUMBERS &&
		css`
			align-items: flex-start;
		`}
`;

const Slide = styled('div')<StyledProps>`
	flex: 0 0 min-content;
	min-width: 0;

	${({$isFullscreen}) =>
		$isFullscreen &&
		css`
			flex: 0 0 100%;
		`}
`;

const StyledButton = styled(Button)<StyledButtonProps>`
	color: ${({$isDarkTheme, theme}) =>
		$isDarkTheme ? theme.palette.other.progressBar : theme.palette.primary.main};

	&:disabled {
		color: ${({$isDarkTheme, theme}) =>
			$isDarkTheme ? alpha(theme.palette.common.white, 0.3) : theme.palette.action.disabled};
	}
`;

export {OuterContainer, InnerContainer, Slide, StyledButton};
